<template>
  <div class="group-members">
    <div class="group-members-header">
      <div class="a" @click="back">
        <img src="./img/back-arrow.png" alt="" />
        <div>返回</div>
      </div>
      <div class="c">群成员</div>
      <div class="d" v-show="groupInfo.user_info.role > 0" @click="isManager = !isManager">管理</div>
    </div>
    <div class="group-members-search">
      <img src="./img/search_grey.png" alt="" />
      <input type="text" placeholder="请输入群成员昵称或ID进行搜索" v-model="searchKey" />
    </div>
    <div class="group-members-list">
      <div class="user" v-show="groupInfoCopy.length > 0">
        <div class="title" v-show="anchorList.length > 0">群主</div>
        <div class="list" v-for="item in anchorList" :key="item.id">
          <div class="list-member">
            <img :src="item.avatar" alt="" class="c" />
            <div class="d text-overflow" v-html="item.nick_name_copy"></div>
          </div>
        </div>
        <div class="title" v-show="managerList.length > 0">房管</div>
        <div class="list" v-for="item in managerList" :key="item.id">
          <div class="list-member">
            <img :src="item.avatar" alt="" class="c" />
            <div class="d text-overflow" v-html="item.nick_name_copy"></div>
          </div>
        </div>
        <div class="title" v-show="userList.length > 0">群成员</div>
        <div class="list" @click="userCheck(item.id)" v-for="item in userList" :key="item.id">
          <div class="list-member">
            <img v-show="isManager" :src="checkArr.includes(item.id) ? require('./img/select-1.png') : require('./img/select.png')" class="a" />
            <img :src="item.avatar" alt="" class="c" />
            <div class="d text-overflow" v-html="item.nick_name_copy"></div>
          </div>
          <div class="list-btn" v-show="groupInfo.user_info.role === 1" @click.stop="toUserChat(item)">私聊</div>
        </div>
      </div>
      <div class="empty" v-show="groupInfoCopy.length === 0 && loading">
        <img src="@/assets/img/empty/no-data.png" alt="" />
        <div>没有搜索到相关的群成员</div>
      </div>
      <img v-show="isDeleteLoading" src="@/assets/img/loading-2.gif" alt="" class="load" />
    </div>
    <div class="group-members-footer" v-show="isManager">
      <div class="btn" @click="userCheckAll">
        <img v-show="!isCheckAll" src="./img/select.png" alt="" />
        <img v-show="isCheckAll" src="./img/select-1.png" alt="" />
        <div>全选</div>
      </div>
      <div class="btn btn1" @click="openConfirmDialog(dialogContent)">
        <img src="./img/delete-red.png" alt="" />
        <div>移出</div>
      </div>
    </div>
    <ConfirmDialog :content="content" @confirmDialog="confirmDialog" ref="confirmDialog" />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { post } from "../../util/http";
import { format } from "@/util/time";
import ConfirmDialog from "@/components/dialog/ConfirmDialog";
export default {
  components: {
    ConfirmDialog,
  },
  computed: {
    ...mapState(["userInfo", "appConfig", "privateMessageList", "groupInfo", "loginRepData", "anchorId"]),
  },
  props: {},
  watch: {
    groupInfoCopy: {
      handler(newVal, oldVal) {
        console.log(newVal, "newVal");
        this.anchorList = [];
        this.managerList = [];
        this.userList = [];
        newVal.forEach((e) => {
          if (e.role === 2) {
            this.anchorList.push(e);
          } else if (e.role === 1) {
            this.managerList.push(e);
          } else {
            this.userList.push(e);
          }
        });
        this.loading = true;
      },
      // immediate: true,
      // deep: true,
    },
    searchKey(newVal) {
      this.loading = false;
      let arr = [];
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.groupMembers.forEach((e) => {
          if (e.nick_name_copy.indexOf(newVal) > -1 || newVal == e.id) {
            let member = Object.assign({}, e);
            member.nick_name_copy = member.nick_name_copy.replace(newVal, `<span style='color:#02a8a2'>${newVal}</span>`);
            arr.push(member);
          }
        });
        this.groupInfoCopy = arr;
      }, 300);
    },
  },
  data() {
    return {
      isManager: false,
      isCheckAll: false,
      groupMembers: [],
      anchorList: [],
      managerList: [],
      userList: [],
      searchKey: "",
      searchTimer: null,
      groupInfoCopy: [],
      checked: 0,
      checkArr: [],
      content: "",
      dialogContent: ["确定要移出选中用户吗？"],
      loading: false,
      isDeleteLoading: false,
    };
  },
  created() {},
  destroyed() {},
  mounted() {
    this.getGroupMembers();
  },
  methods: {
    ...mapMutations(["pushToast"]),
    ...mapActions(["getChatList", "getAnchorProfile", "getGroupInfo"]),
    toUserChat(item) {
      console.log("toUserChat", item, this.$route.path);
      // if (this.$route.path === '/user-center/privateChat') {

      // } else {

      //   }
      this.$emit("toUserChat", item);
    },
    back() {
      this.$emit("changeGroupMembers", false);
    },
    userCheck(item) {
      if (!this.isManager) return;
      if (this.checkArr.includes(item)) {
        this.checkArr = this.checkArr.filter((e) => e !== item);
      } else {
        this.checkArr.push(item);
      }
      console.log(item, this.checkArr);
    },
    userCheckAll() {
      if (this.isCheckAll) {
        this.checkArr = [];
        this.isCheckAll = false;
      } else {
        this.userList.forEach((e) => {
          this.checkArr.push(e.id);
        });
        this.isCheckAll = true;
      }
    },
    openConfirmDialog(val) {
      if (this.checkArr.length === 0) {
        this.pushToast("请勾选需要移出用户");
        return;
      }
      this.content = val;
      this.$refs.confirmDialog.open();
    },
    confirmDialog(val) {
      if (val === this.dialogContent) {
        this.kickUser();
      }
    },
    getGroupMembers() {
      post({
        url: "/api/groupChat/getGroupMembers",
        data: {
          group_id: this.groupInfo.id,
          page: 1,
          search: "",
          size: 500,
        },
      })
        .then(({ data: { data } }) => {
          this.groupMembers = data.members || [];
          this.groupMembers.forEach((e) => {
            e.nick_name_copy = e.nick_name;
          });
          let str = JSON.stringify(this.groupMembers);
          this.groupInfoCopy = JSON.parse(str);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    kickUser() {
      console.log(this.checkArr, "this.checkArr");
      this.isDeleteLoading = true;
      if (this.checkArr.length === 0) {
        this.pushToast("请勾选需要移出用户");
        return;
      }
      post({
        url: "/api/groupChat/kickUser",
        data: {
          group_id: this.groupInfo.id,
          kick_user_ids: this.checkArr,
        },
      })
        .then(({ data }) => {
          this.$message.success("移出用户成功！");
          this.isDeleteLoading = false;
          this.getGroupInfo();
          this.getGroupMembers();
          this.getAnchorProfile(this.anchorId);
          this.getChatList();
        })
        .catch((e) => {
          this.isDeleteLoading = false;
          console.log(e);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.group-members {
  margin-top: 0.12rem;
  margin-right: 0.4rem;
  width: 3.4rem;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  position: relative;
  .group-members-header {
    height: 0.42rem;
    display: flex;
    align-items: center;
    background: linear-gradient(0deg, rgba(2, 168, 162, 0.15), rgba(2, 168, 162, 0.15)), #ffffff;
    .a {
      display: flex;
      width: 0.8rem;
      color: #666666;
      font-size: 0.12rem;
      cursor: pointer;
      img {
        width: 0.16rem;
        height: 0.16rem;
        margin-left: 0.12rem;
        margin-right: 0.05rem;
      }
    }
    .c {
      flex: 1;
      text-align: center;
      color: #000000;
    }
    .d {
      width: 0.8rem;
      color: #666666;
      font-size: 0.12rem;
      text-align: end;
      padding-right: 0.12rem;
      cursor: pointer;
    }
  }
  .group-members-search {
    display: flex;
    align-items: center;
    width: 3.16rem;
    height: 0.4rem;
    background: #f9f9fb;
    border-radius: 0.04rem;
    margin: 0.1rem auto;
    padding: 0 0.16rem;
    img {
      width: 0.24rem;
      height: 0.24rem;
      margin-right: 0.08rem;
    }
    input {
      flex: 1;
    }
    input::placeholder {
      color: #c4cacc;
      font-size: 0.14rem;
    }
  }
  .group-members-list {
    padding: 0 0.12rem;
    flex: 1;
    overflow: scroll;
    .load {
      width: 1rem;
      height: 1.2rem;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 2rem;
    }
    .user {
      .title {
        width: 3.16rem;
        height: 0.32rem;
        line-height: 0.32rem;
        background: #f4f4f4;
        border-radius: 0.04rem 0.04rem 0px 0px;
        font-size: 0.12rem;
        color: #666666;
        padding-left: 0.16rem;
      }
      .list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 0.08rem;
        height: 0.64rem;
        cursor: pointer;
        .list-member {
          display: flex;
          align-items: center;
          .a {
            width: 0.16rem;
            margin-right: 0.06rem;
          }
          .c {
            width: 0.4rem;
            height: 0.4rem;
            border-radius: 0.4rem;
            margin-right: 0.06rem;
          }
          .d {
            font-size: 0.16rem;
            max-width: 2rem;
            span {
              color: #02a8a2;
            }
          }
        }
        .list-btn {
          width: 0.6rem;
          height: 0.32rem;
          line-height: 0.32rem;
          text-align: center;
          border-radius: 0.04rem;
          background: #02a8a2;
          color: #ffffff;
          cursor: pointer;
        }
      }
    }
    .empty {
      flex: 1;
      text-align: center;
      margin-top: 1.5rem;
      color: #999999;
      img {
        width: 2.7rem;
        margin-bottom: 0.2rem;
      }
    }
  }
  .group-members-footer {
    width: 100%;
    height: 0.7rem;
    box-shadow: 0px -6px 4px rgba(191, 200, 227, 0.1), inset 0px 0.5px 0px #f0f0f0;
    // position: absolute;
    // bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    background: #ffffff;
    .btn {
      width: 1.2rem;
      height: 0.36rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #eee;
      border-radius: 0.04rem;
      color: #666666;
      font-size: 0.16rem;
      cursor: pointer;
      img {
        margin-right: 0.04rem;
        width: 0.16rem;
      }
    }
    .btn1 {
      border: 1px solid #db6372;
      color: #db6372;
    }
  }
}
</style>
